import { clearTrailingSlash, consoleLogAPI, getRedirectLocale } from 'src/common/functions'
import getGameStatus from 'src/apollo/queries/getGameStatus.gql'

const locale = `:locale(${process.env.LOCALES})?`
import { postMessageFromWebviewToApp } from 'src/common/webview'
import { defineAsyncComponent } from 'vue'
import { $apollo } from 'src/apollo/apollo-options-api'
import { getConfig } from 'src/configs'
import HomePage from 'src/pages/Home.vue'

const config = getConfig()

let extraRoutes = []
let landingsRoutes = []
let webviewRoutesFunction = () => {}
let bookmakerRoutesFunction = () => {}

if (process.env.PLATFORM === 'olimp') {
  extraRoutes = require('./olimp/extra.js').default
  landingsRoutes = require('./olimp/landings.js').default
  webviewRoutesFunction = require('./olimp/webview.js').default
  bookmakerRoutesFunction = require('./olimp/bookmaker.js').default
} else if (process.env.PLATFORM === 'olymp') {
  extraRoutes = require('./olymp/extra.js').default
  landingsRoutes = require('./olymp/landings.js').default
  webviewRoutesFunction = require('./olymp/webview.js').default
  bookmakerRoutesFunction = require('./olymp/bookmaker.js').default
}

const HAS_BK = !!process.env.OWN_SPORT

const routes = async (store) => {
  const isBot = store.getters.getIsBot
  const redirectToLocale = getRedirectLocale()

  let bookmakerRoutes = []
  if (HAS_BK) {
    bookmakerRoutes = bookmakerRoutesFunction(store)
  }

  const casRoutesBase = HAS_BK ? 'casino' : ''

  const baseRoutes = [
    {
      path: '',
      name: 'Home',
      meta: { auth: false },
      component: HomePage,
    },
    {
      path: 'favorites',
      name: 'Favorites',
      component: () => import('pages/Favorites'),
    },
    {
      path: 'competitions/:type?',
      name: 'Competitions',
      meta: { auth: false, isHeaderSliderNotSticky: true },
      component: () => import('pages/Competitions.vue'),
    },
    {
      path: 'competition/:id?',
      name: 'Competition',
      meta: { auth: false },
      component: () => import('components/competitions/CompetitionNew.vue'),
    },
    {
      path: 'promotion/:id',
      name: 'Promotion',
      component: () => import('pages/PromotionItem.vue'),
    },
    {
      path: 'promo/:type',
      name: 'Promo',
      meta: { auth: false, isHeaderSliderNotSticky: true },
      component: () => import('pages/Promo.vue'),
    },
    {
      path: 'promo',
      redirect: 'promo/all',
    },
    {
      name: 'cashback',
      path: 'cashback',
      component: () => import('src/pages/Cashback.vue'),
    },
    {
      name: 'rules',
      path: 'rules',
      meta: { isHeaderSliderHidden: true },
      component: () => import('src/pages/Rules.vue'),
    },
    {
      name: 'drops-wins',
      path: 'drops',
      component: () => import('src/pages/Drops-wins'),
    },
    {
      name: 'cabbage-days',
      path: 'cabbage-days',
      component: () => import('src/pages/Cabbage-days'),
    },
    {
      name: 'rule',
      path: 'rule/:rule',
      meta: { isHeaderSliderHidden: true },
      component: () => import('src/pages/Rule.vue'),
    },
    {
      path: 'auth-social/login/',
      name: 'auth-social',
      component: () => import('src/components/user/auth/AuthSocialWindow.vue'),
    },
    {
      name: 'Auth',
      path: 'accounts/login/:slug/:slug2/',
      component: HomePage,
    },
    {
      name: 'AuthEmail',
      path: 'accounts/login/:slug/:slug2/email',
      component: HomePage,
    },
    {
      path: 'result',
      name: 'Result',
      meta: { auth: false },
      component: () => import('pages/Result.vue'),
    },
    {
      path: '',
      component: () => import('layouts/MainLayout.vue'),
      children: [
        {
          path: config.groupRootPath,
          name: 'Casino',
          redirect: { name: 'GamesByGroup', params: { group: 'slot' } },
        },
        {
          path: `${config.groupRootPath}/:group/:subgroup`,
          name: 'GamesBySubGroup',
          component: () => import('pages/GameGroup'),
        },
        {
          path: `${config.groupRootPath}/:group`,
          name: 'GamesByGroup',
          component: () => import('pages/GameGroup'),
        },
        {
          path: 'games/user-bonus',
          name: 'BonusGames',
          meta: { auth: true },
          component: () => import('pages/GamesByUserBonus'),
        },
        {
          path: 'games/:manufacturer',
          name: 'GamesByManufacturer',
          component: () => import('pages/GamesByManufacturer'),
        },
      ],
    },
    {
      path: 'profile',
      meta: { auth: true, isSeoBlockHidden: true },
      redirect: () => ({ name: 'balance' }),
      component: () => import('src/pages/profile/Profile.vue'),
      children: [
        {
          path: '',
          name: 'profile',
          meta: { auth: true, isSeoBlockHidden: true },
          component: () => import('src/pages/profile/Information'),
        },
        {
          path: 'balance',
          name: 'balance',
          meta: { auth: true, isSeoBlockHidden: true },
          component: () => import('src/pages/profile/Balance'),
        },
        {
          path: 'bonuses',
          name: 'bonuses',
          meta: { auth: true, isSeoBlockHidden: true },
          component: () => import('src/pages/profile/BonusesView'),
        },
        {
          path: 'messages',
          name: 'messages',
          meta: { auth: true, isSeoBlockHidden: true },
          component: () => import('src/pages/profile/MessagesView'),
        },
      ],
    },
    {
      name: 'GamePageNew',
      path: 'games/:manufacturer?/:game?',
      meta: { isFooterHidden: true, isLiveChatHidden: true, isHeaderSliderHidden: true },
      component: () => import('layouts/GameLayoutNew'),
      beforeEnter: (to, from, next) => {
        const isAuth = store.getters.getAuth
        const variables = {
          manufacturer: to.params.manufacturer,
          supplier: to.query.supplier,
          free: !store.getters.getToken ? true : to.query.free === '1',
          s: to.query.s,
          freegame: to.query.freegame,
          slug: to.params.game,
          withoutInit: true,
        }
        const isAviatorNotAvailable = isAuth
          ? store.getters.getUserCurrencyCode === 'RUB'
          : store.getters.getRegion === 'RU'

        if (to.params.game === 'spribe-aviator' && isAviatorNotAvailable) {
          const params = {
            game: 'aviatrix-nft-aviatrix',
            manufacturer: 'avx',
          }
          next({ ...to, params })
        }

        if (!isAuth) {
          return next()
        }

        $apollo
          .query({
            query: getGameStatus,
            variables,
            fetchPolicy: 'network-only',
          })
          .then(({ data }) => {
            if (data.gameInit.statusCode !== 'DISABLED_BY_PROMO') {
              const program = store.getters.getActiveUserProgram?.program
              const isSwitchBalanceDenied =
                program?.processConditions?.includes(4) || program?.processConditions?.includes(5)
              const isNoVagerGame =
                isSwitchBalanceDenied &&
                !store.getters.getUserBonusBalanceOn &&
                store.getters.getActiveStep?.condition === 6
              const isNoBonusGame = !store.getters.getBonusGameIdsList?.includes(data.gameInit.game.gameId)
              if (isNoVagerGame && isNoBonusGame && from.name !== undefined) {
                store.commit('PUSH_MODAL', {
                  componentName: defineAsyncComponent(() => import('src/components/games/NonBonusVagerModal.vue')),
                  isMaximized: false,
                  position: 'bottom',
                  props: { gamePath: () => next() },
                })
                return
              } else {
                next()
                return
              }
            }
            if (from.name !== undefined) {
              store.commit('PUSH_MODAL', {
                componentName: defineAsyncComponent(() => import('src/components/games/NonBonusGameModal.vue')),
                props: { gamePath: () => next() },
              })
            } else {
              next()
            }
          })
          .catch((e) => {
            consoleLogAPI(e)
            next()
          })
      },
    },
  ]

  const errorRoute = {
    path: ':catchAll(.*)*',
    name: '404page',
    meta: { auth: false, isFooterHidden: true },
    component: () => import('src/pages/NotFound.vue'),
  }

  const childrenRoutes = HAS_BK
    ? [
        ...bookmakerRoutes,
        ...extraRoutes,
        ...baseRoutes.map((item) => {
          if (item.path) {
            item.path = `${casRoutesBase}/${item.path}`
          } else {
            item.path = casRoutesBase
          }
          return item
        }),
        errorRoute,
      ]
    : [...extraRoutes, ...baseRoutes, errorRoute]
  const webviewRoutes = process.env.WEBVIEW ? webviewRoutesFunction(locale) : []

  const ignoredRoutes = ['euro_slots', 'new-year']
  const land = landingsRoutes.length
    ? [
        {
          path: `/${locale}/land`,
          component: () => import('layouts/LandingLayout.vue'),
          children: landingsRoutes,
          beforeEnter: (to, from, next) => {
            const isUserAccount = localStorage.getItem('hasAccount') || store.getters.getUser
            isUserAccount && !ignoredRoutes.includes(to.name) ? next(redirectToLocale) : next()
          },
        },
      ]
    : []
  const additionalRoutes =
    store.getters.getIsAlt && !isBot
      ? [
          {
            component: () => import('layouts/LandingLayout.vue'),
            path: '/session-auth',
            meta: { auth: false, isFooterHidden: true, isSeoBlockHidden: true },
            children: [
              {
                path: '',
                name: 'session-auth',
                component: () => import('src/pages/AuthBySession.vue'),
              },
            ],
          },
        ]
      : []

  return [
    ...land,
    ...webviewRoutes,
    {
      path: `/${locale}`,
      component: () => import('layouts/CommonLayout.vue'),
      children: childrenRoutes,
      beforeEnter(to, from, next) {
        if (store.getters.isWebView && to.hash.startsWith('#payment_')) {
          return postMessageFromWebviewToApp(to.hash.replace('#', ''))
        }

        next()
      },
    },
    ...additionalRoutes,
    {
      path: '/*',
      redirect: (to) => {
        const url = `${redirectToLocale}${to.path}`.replace('//', '/')
        return clearTrailingSlash(url)
      },
    },
  ]
}
export default routes
